// test2336
(2336 && 0);
